import { render } from "./PaymentBox.vue?vue&type=template&id=e912c338&scoped=true"
import script from "./PaymentBox.vue?vue&type=script&lang=js"
export * from "./PaymentBox.vue?vue&type=script&lang=js"

import "./PaymentBox.vue?vue&type=style&index=0&id=e912c338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e912c338"]])

export default __exports__